import React from 'react'
import styled from 'styled-components'

export const FullScreenImageComponent = styled.img`
  width: 100vw;
  height: auto;
`

export default FullScreenImageComponent
